import { v2Api } from './v2Client';

const LOG = '[SquashAPI terrainBookingRule]';

function normalizeRule(row) {
  if (!row) return null;
  const id = row.id ?? row.Id;
  if (id == null) return null;
  return {
    id: String(id),
    sport: row.sport ?? row.Sport ?? 'squash',
    terrain_id: row.terrain_id ?? row.terrainId ?? row.TerrainId ?? null,
    requires_prepayment: Boolean(row.requires_prepayment ?? row.requiresPrepayment ?? row.RequiresPrepayment ?? false),
    // "online" | "on_site" | "all" (voir squash_manger_api_v2 Services/CourtPaymentModes.cs).
    payment_mode: row.payment_mode ?? (row.requires_prepayment ? 'online' : 'all'),
    cancellation_cutoff_minutes:
      row.cancellation_cutoff_minutes ?? row.cancellationCutoffMinutes ?? row.CancellationCutoffMinutes ?? null,
    created_at: row.created_at ?? row.createdAt ?? row.CreatedAt ?? null,
  };
}

/** GET /TerrainBookingRule/list */
export async function listBookingRules() {
  try {
    const { data } = await v2Api.get('/TerrainBookingRule/list');
    const rows = Array.isArray(data) ? data : [];
    return rows.map(normalizeRule).filter(Boolean);
  } catch (err) {
    console.error(LOG, 'list échoué', err);
    throw err;
  }
}

/** POST /TerrainBookingRule/create */
export async function createBookingRule(payload) {
  try {
    const { data } = await v2Api.post('/TerrainBookingRule/create', payload);
    return normalizeRule(data) ?? data;
  } catch (err) {
    console.error(LOG, 'create échoué', { payload, err });
    throw err;
  }
}

/** POST /TerrainBookingRule/update */
export async function updateBookingRule(payload) {
  try {
    const { data } = await v2Api.post('/TerrainBookingRule/update', payload);
    return normalizeRule(data) ?? data;
  } catch (err) {
    console.error(LOG, 'update échoué', { payload, err });
    throw err;
  }
}

/** POST /TerrainBookingRule/delete — hard delete accepté ici (config pure, pas d'historique attaché). */
export async function deleteBookingRule(id) {
  try {
    const { data } = await v2Api.post('/TerrainBookingRule/delete', { id: String(id) });
    return data;
  } catch (err) {
    console.error(LOG, 'delete échoué', { id, err });
    throw err;
  }
}

export const terrainBookingRuleService = {
  list: listBookingRules,
  create: createBookingRule,
  update: updateBookingRule,
  remove: deleteBookingRule,
};
